// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism.css"
import "./src/styles/skeleton.css"
import "./src/styles/normalize.css"
import "./src/styles/bodyshim.css"